import type { Tokens } from '../../../theming/types'
import type { MenuWithStateProps } from '../MenuWithState'

const menuMaxWidth = '304px'

export default (config: {
  props: Pick<MenuWithStateProps, 'minWidth' | 'isNestedMenu'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    menuWidthHelper: {
      marginInlineStart: props.isNestedMenu ? tokens.spacingGap100 : undefined,
      marginBlockStart: props.isNestedMenu
        ? `-${tokens.spacingGap100}`
        : undefined,
      maxWidth: props.minWidth ? undefined : menuMaxWidth,
    },
  } as const
}
